import React, { createContext, useState, useContext, useEffect, useRef } from "react";
import { useAuth } from "../hooks";
import { Auth } from "../api";
import { isAdmin, isMaster } from "../utils/checkPermission";

const authController = new Auth();

// Creamos el contexto
const SiteContext = createContext();

// Proveedor del contexto
export const SiteProvider = (props) => {
  const { children } = props;
  const { user, accessToken, login } = useAuth();
  const [site, setSite] = useState(() => {
    const storedSite = localStorage.getItem("site");
    return storedSite ? storedSite : "";
  }); // Estado inicial del idioma, por defecto ''

  const hadUser = useRef(false);

  // Editor/reviewer con más de un sitio asignado: cambiar de sitio implica
  // reemitir los tokens (el JWT lleva el sitio activo, y eso es lo que
  // habilita/restringe qué puede escribir en el servidor).
  const changeSite = async (newSite) => {
    const hasMultipleSites = !isMaster(user?.role) && !isAdmin(user?.role) && (user?.sites || []).length > 1;

    if (hasMultipleSites && newSite) {
      try {
        const response = await authController.switchSite(accessToken, newSite);
        const remember = authController.isRemembered();
        authController.setAccessToken(response.access, remember);
        authController.setRefreshToken(response.refresh, remember);
        await login(response.access);
      } catch (error) {
        console.error(error);
        return;
      }
    }

    setSite(newSite);
  };

  useEffect(() => {
    localStorage.setItem("site", site);
  }, [site]);

  useEffect(() => {
    if (!user) {
      // Solo limpiar si ya hubo un usuario (logout real), no en la carga inicial
      if (hadUser.current) {
        setSite("");
      }
    } else {
      hadUser.current = true;
      const stored = localStorage.getItem("site");
      setSite(stored || "");
    }
  }, [user]);

  return (
    <SiteContext.Provider value={{ site, changeSite }}>
      {children}
    </SiteContext.Provider>
  );
};

// Hook personalizado para consumir el contexto
export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error("useSitio debe ser usado dentro de un SitioProvider");
  }
  return context;
};
